import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { hrApi } from '../../api/hr.js';

export default function OrgChart() {
  const [tree, setTree] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    hrApi.orgChart().then((d) => setTree(d?.tree)).catch((e) => setError(e.response?.data?.message || 'Failed'));
  }, []);

  if (error) return <div className="alert error">{error}</div>;
  if (!tree) return <div className="muted">Loading…</div>;

  return (
    <section>
      <header className="page-header"><h1>Organization Chart</h1></header>
      <div className="card org-chart-wrap">
        <Tree node={tree} root />
      </div>
    </section>
  );
}

function Tree({ node, root = false }) {
  return (
    <div className={`org-node ${root ? 'org-root' : ''}`}>
      <NodeCard node={node} />
      {node.children && node.children.length > 0 && (
        <div className="org-children">
          {node.children.map((c) => (
            <Tree key={c.id} node={c} />
          ))}
        </div>
      )}
    </div>
  );
}

function NodeCard({ node }) {
  if (node.id === 'root') {
    return <div className="org-card org-virtual">{node.name}</div>;
  }
  return (
    <Link to={`/hr/employees/${node.id}`} className="org-card">
      <div className="avatar">{(node.name || '?').charAt(0).toUpperCase()}</div>
      <div className="info">
        <div className="name">{node.name}</div>
        <div className="muted small">{node.title || '—'}</div>
        <div className="muted small">{node.department || ''}</div>
      </div>
    </Link>
  );
}
